import api from '@/api'
import axios from 'axios'

export default {
  hasToken() {
    return localStorage.token && localStorage.token.length > 10
  },

  getToken() {
    return localStorage.token
  },

  setToken(token) {
    localStorage.token = token
  },

  authenticate(email, password) {
    return axios.post(api.baseUrl + '/auth', { email, password })
  }
}